<template>
  <v-container fluid class="fullHeight">
    <v-layout column class="fullHeight">
      <v-flex xs12 class="fullHeight">
        <v-tabs
          v-model="tabsValue"
          align-with-title
          color="secundary"
          slider-color="red"
          dark
        >
          <v-tab v-for="(item, i) in tabs" :key="i">
            {{ item.name }}
          </v-tab>
          <v-layout row align-end>
          </v-layout>
          <info :title="info.title" :content="info.content"/>
        </v-tabs>
        <v-tabs-items v-model="tabsValue" fixed-tabs class="fullHeight">
          <v-tab-item class="fullHeight" v-for="(item, i) in tabs" :key="i">
            <v-card class="fullHeight">
              <component :is="item.chart" class="fullHeight"/>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import tpsBarChart from './Charts/TimePerSceneBarChart'
import NumberOfProductsAddedToCart from './Charts/NumberOfProductsAddedToCart'
import NumberOfProductsConsulted from './Charts/NumberOfProductsConsulted'
import AllClickedItems from './Charts/AllClickedItems'
import ClicksPerSession from './Charts/ClicksPerSession'
import axios from 'axios'

export default {
  data () {
    return {
      currentUser: {},
      admin: false,
      tabs: [],
      tabsValue: null,
      currentUser_RightsGroups: [],
      info: {
        title: this.$vuetify.t('$vuetify.info.products.title'),
        content: [
          this.$vuetify.t('$vuetify.info.products.content.1'),
          this.$vuetify.t('$vuetify.info.products.content.2')
        ]
      }
    }
  },
  props: {
    graph: {
      type: Number,
      required: false,
      default: 0
    }
  },
  watch: {
    tabsValue (value) {
      this.$router.replace(this.$route.path + '?graph=' + value)
    }
  },
  created () {
    var x = setInterval(() => {
      this.currentUser_RightsGroups = JSON.parse(this.$root.$children[0].currentUser_RightsGroupsStringified)
      if (this.currentUser_RightsGroups != []){
        clearInterval(x)
        if (this.currentUser_RightsGroups.includes('GlobalStats') && this.currentUser_RightsGroups.includes('DetailedStats') && this.currentUser_RightsGroups.includes('ExpertStats')){
          this.tabs = [
            {
              name: this.$vuetify.t('$vuetify.charts.numberOfProductsAddedToCart.legend'),
              chart: 'number-of-products-added-to-cart'
            },
            {
              name: this.$vuetify.t('$vuetify.charts.numberOfProductsConsulted.legend'),
              chart: 'number-of-products-consulted'
            },
            {
              name: this.$vuetify.t('$vuetify.charts.clicksPerSession.legend'),
              chart: 'clicks-per-session'
            },
            {
              name: this.$vuetify.t('$vuetify.charts.allClickedItems.legend'),
              chart: 'all-clicked-items'
            }
          ]
        }
        else if (this.currentUser_RightsGroups.includes('GlobalStats') && this.currentUser_RightsGroups.includes('DetailedStats')){
          this.tabs = [
            {
              name: this.$vuetify.t('$vuetify.charts.numberOfProductsAddedToCart.legend'),
              chart: 'number-of-products-added-to-cart'
            },
            {
              name: this.$vuetify.t('$vuetify.charts.numberOfProductsConsulted.legend'),
              chart: 'number-of-products-consulted'
            },
            {
              name: this.$vuetify.t('$vuetify.charts.clicksPerSession.legend'),
              chart: 'clicks-per-session'
            }
          ]
        }
        else if (this.currentUser_RightsGroups.includes('GlobalStats')){
          this.tabs = []
        }
      }
    }, 200)
  },
  mounted () {
    this.tabsValue = this.graph
  },
  components: {
    'number-of-products-added-to-cart': NumberOfProductsAddedToCart,
    'number-of-products-consulted': NumberOfProductsConsulted,
    'clicks-per-session': ClicksPerSession,
    'all-clicked-items': AllClickedItems,
  },
  name: 'Time'
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.fullHeight {
  height : calc(100% - 25px);
}
.tabText {
  text-decoration-color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Products.vue